export const msalConfig = {
    auth: {
        clientId: "0299ed2a-dbdb-435c-ad08-8526cf6e07f1",
        authority: "https://login.microsoftonline.com/137a4311-a8e5-4036-964d-11f9cc11e2bd",
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};